import gql from 'graphql-tag';

export const deleteContactList = gql`
  mutation deleteContactList($id: String) {
    deleteContactList(id: $id) {
      value
    }
  }
`;
